<!-- Start: Main -->
<div id="main">

  <section id="content_wrapper">

    <section id="content" style="margin-top: 50px; margin-left: -80px;" class="table-layout animated fadeIn">


      <!-- begin: .tray-center -->
      <div class="tray tray-center">


      <router-outlet></router-outlet>

      </div>


    </section>

</section>

</div>
